import { render, staticRenderFns } from "./CommandesIndividuelles.vue?vue&type=template&id=2722bc6e&scoped=true"
import script from "./CommandesIndividuelles.vue?vue&type=script&lang=js"
export * from "./CommandesIndividuelles.vue?vue&type=script&lang=js"
import style0 from "./CommandesIndividuelles.vue?vue&type=style&index=0&id=2722bc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2722bc6e",
  null
  
)

export default component.exports